import { NexaAskRequest } from '@src/components/nexa/types/askNexa';

const { baseUrl } = window.conviva;

/**
 * Navigates to Nexa with an Ask Nexa request
 * Encodes the request as base64 and navigates to /nx/ask
 * @param request - The NexaAskRequest to send
 * @param navigate - React Router navigate function
 */
export function navigateToNexaWithRequest(request: NexaAskRequest, navigate: any): void {
  try {
    // Encode request as base64
    const jsonString = JSON.stringify(request);
    const base64Encoded = btoa(jsonString);

    // Navigate to /nx/ask with encoded request
    const url = `${baseUrl}/nx/ask?req=${encodeURIComponent(base64Encoded)}`;
    navigate(url);
  } catch (error) {
    console.error('[navigateToNexa] Failed to encode and navigate:', error);
    // Fallback: navigate to Nexa without prefill
    navigate(`${baseUrl}/dashboard/nexa`);
  }
}
